import { atom } from "jotai";

export const COMPANY_NAVBAR_MOBILE_IS_OPEN_ATOM = atom<boolean>(false);
